<script setup>
import { ref, watch, onMounted, onUnmounted} from 'vue'
import FilterRangeSlider from "@/components/common/RangeSlider.vue"
import FilterSingleSlider from "@/components/common/SingleSlider.vue"

//properties set by parent
/*  const props = defineProps({
	dim: {
		type: Object,
		required: false,
	}
})  */

//events raised by component
const emit = defineEmits([
	'closeFilterItemPanel',
	'updateFilterValue'
])

//componenet methods exposed to parent
 defineExpose({
    initFilterItem
});

//reactive field proxies
const  dimName = ref()
const range = ref([0,0]);
const dim = ref({})
const xAxisDim = ref({})
const seriesDim = ref({})
const chartType = ref({})
const singleValue = ref(0)

const min=ref(0)
const max=ref(0)


//local variables
let timeoutId = null;
let unwatchRange = null
let unwatchSingle = null

//methods
function initFilterItem(type, selectedDim, xDim, sDim) {
	dim.value = selectedDim
	dimName.value = selectedDim.columnName
	chartType.value = type
	seriesDim.value = sDim
	xAxisDim.value = xDim
	min.value = Math.min(...dim.value.distinctValues.map(Number))
	max.value = Math.max(...dim.value.distinctValues.map(Number))

	//max.value = Math.max(parseInt(dim.value.distinctValues))

	let top, low
	let tmpArr = selectedDim.appliedValues.filter(i => i.selected)

	low = Math.min(...tmpArr.map(i => Number(i.name)))
	top = Math.max(...tmpArr.map(i => Number(i.name)))	
	
	if(unwatchRange)
		unwatchRange()

	if(unwatchSingle)
		unwatchSingle()		

	range.value = [low, top]
	singleValue.value = low

	//Workaround for range slider to prevent watch from invoking updateFilter() each time filter panel is opened
 	unwatchRange = watch(
		range,
		([newMin, newMax], [oldMin, oldMax]) => {
			if(oldMin == 0 && oldMax == 0) {
				return;
			} else if(oldMin == newMin && oldMax == newMax) {
				return;
			}
			//console.log('range: ' + newMin + "," + newMax)
			dim.value.appliedValues.forEach(v => {
				if(parseInt(v.name) < parseInt(newMin) ||
				parseInt(v.name) > parseInt(newMax))
					v.selected = false;
				else
					v.selected = true;
			})
			updateFilter();
		}
	);

 	unwatchSingle = watch(		
		singleValue, (newVal, oldVal) => {
			if(oldVal == 0) {
				return;
			} else if(oldVal == newVal) {
				return;
			}			
			dim.value.appliedValues.forEach(v => {
				if(parseInt(v.name) == parseInt(newVal))
					v.selected = true;
				else
					v.selected = false;
			})
			updateFilter();		
		}
	); 	
}

function closeFilter(type) {
	emit('closeFilterItemPanel', type);
}

function updateFilter() {
	//console.log(dim)
	emit('updateFilterValue', dim.value);
}

function resetAll() {
	dim.value.appliedValues.forEach(i => {
		i.selected = true
	})
	range.value = [parseInt(dim.value.distinctValues[0]), parseInt(dim.value.distinctValues[dim.value.distinctValues.length-1])]
	emit('updateFilterValue', dim.value);	
}

onUnmounted(() => {
	console.log('slider unmounted')
})

/* 
onMounted(() => {
	console.log('filter opened')
 	watch(		
		singleValue, (newVal, oldVal) => {
			if(oldVal == 0) {
				return;
			} else if(oldVal == newVal) {
				return;
			}			
			dim.value.appliedValues.forEach(v => {
				if(parseInt(v.name) == parseInt(newVal))
					v.selected = true;
				else
					v.selected = false;
			})
			updateFilter();		
		}
	); 
}) */


</script>

<template>
	<div class="filter-panel">
		<div class="filter-header">
			<button class="btn-icon btn-arrow" @click="closeFilter" aria-label="Back"><i class="fa-solid fa-chevron-left"></i> Back</button>
			<button class="btn-icon btn-close" @click="closeFilter('all')" aria-label="Close"><i class="fa-solid fa-times"></i></button>
		</div>
		<div class="filter-title">{{dimName}}</div>
		
		<div class="filter-body">
			<div v-if="chartType == 'line' || chartType == 'table'" class="filter-body-content">
				<FilterRangeSlider  v-model="range" :min="min" :max="max" />
				<div class="button-section">
					<button class="btn-primary" @click="resetAll"> <i class="fa-solid fa-trash-can-undo"></i> Reset All </button>
				</div>
			</div>
			<div v-else-if="chartType == 'column' || chartType == 'bar' || chartType == 'treemap' || chartType == 'sankey'" class="filter-body-content">
				<div v-if="(seriesDim.columnName !=null && dim.columnName == seriesDim.columnName && seriesDim.appliedValues.length > 1) || (xAxisDim.columnName !=null && dim.columnName == xAxisDim.columnName && xAxisDim.appliedValues.length > 1)" class="filter-body-content">
					<FilterRangeSlider  v-model="range" :min="min" :max="max" />
					<div class="button-section">
						<button class="btn-primary" @click="resetAll"> <i class="fa-solid fa-trash-can-undo"></i> Reset All </button>
					</div>
				</div>				
				<div v-else>
					<FilterSingleSlider  v-model="singleValue" :label="dimName" :min="min" :max="max" />
				</div>
			</div>
			<div v-else-if="chartType == 'map'" class="filter-body-content" >
				<FilterSingleSlider  v-model="singleValue" :label="dimName" :min="min" :max="max" />
			</div>
		</div>
	</div>
</template>

<style scoped>
.filter-panel {
	background-color: var(--surface-color-Default);
	display: flex;
	width: 25rem; /* 400px; */ 
	flex-direction: column;
	align-items: flex-start;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-xl, 1.5rem);
	flex-shrink: 0;
	padding: .75rem 1.25rem;
	border-radius: var(--ui-cards-default, 0.75rem);
	background: var(--surface-default, #FFF);
	height: 100%;
	/* UI Card */
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);	

	position:absolute;
	top:0;
	left:0;

}
.filter-header {
	display: flex;
	width: 100%; /* 394px; */
	height: 2.5rem;
	justify-content: space-between;
}

.filter-body {
	width: 100%;
	height: 100%;
	min-height: 0;
}
.filter-body-content {
	width: 100%;
	display: flex;
  	flex-direction: column;
  	height: 100%;
}

.filter-title {
	color: var(--text-Header, #171717);

	/* Medium/H6 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6, 1.25rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H6, 1.75rem); /* 140% */
}

.btn-close {
	color: var(--icon-cta-Blue, #064291);
	text-align: right;
	font-weight: 900;
	line-height: normal;
	font-size: var(--font-size-H6);
	border: 0;
	background-color: transparent;
	min-width: 1rem;
}

.btn-arrow {
	min-width:0;
	color: var(--icon-cta-Blue, #064291);
	font-size: var(--font-size-Base);
	text-decoration: none;		
}

.filters {
	display: flex;
	padding-inline-start: 0;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;

	list-style-type: none;
	max-height: 520px;
	overflow-y: auto;
	overflow-x: hidden;
}

ul {
	list-style-type: none;
    padding-left: 0;
    width: 100%;	
}

li {
	display: flex;
	align-items: center;
	align-self: stretch;
	height: 3rem;
	width: 100%;
}

.fld-value {
	padding-left: .25rem;
	color: var(--text-primary, #2C2C2C);

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */		
}

.button-section {
	display: flex;
	justify-content:end;
	width: 100%;
	border-top: 1px solid var(--border-color-Divider);
	margin-top: auto;
	padding-top: 20px;

}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.filter-panel {
		position:absolute;
		left: 0;
		top: 0;
		width: 100%;
		min-height: unset;
	}

	.filter-body {
		max-width: 31.1875rem;
		width: 100%;
	}

	.filters {
		min-height: unset;
	}
}

</style>